<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <h1 class="display-2 font-weight-light mb-8">
      My Portfolio
    </h1>

    <v-responsive
      class="mx-auto subtitle-1 grey--text"
      max-width="550"
    >
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum veniam atque quas eligendi officiis nemo at praesentium molestiae, veritatis doloremque delectus nostrum provident temporibus aliquid autem ipsam ducimus magnam porro.
    </v-responsive>
  </section>
</template>

<script>
  export default {
    name: 'PortfolioHeadline',
  }
</script>
